import { useState,useEffect } from "react";
import UseInView from "./useInView";

const Reveal = ({ children, direction="up", delay=0, className="" }) => {
  const [ref,vis] = UseInView();
  const t = {up:"translateY(70px)",left:"translateX(-70px)",right:"translateX(70px)",scale:"scale(0.92)"};
  return <div ref={ref} className={className} style={{opacity:vis?1:0,transform:vis?"none":(t[direction]||t.up),transition:`opacity 1.3s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 1.3s cubic-bezier(0.16,1,0.3,1) ${delay}s`}}>{children}</div>;
};

export default Reveal